export const paymentMethodDisplayName = {
    escrow: 'Mortgage Bill',
    cc: 'Credit Card',
    ach: 'Bank Account (ACH)'
};

export const maxPaymentsPerPage = 3;
